import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
	HttpService,
	GET,
	Adapter,
	POST,
	Body,
	ResponeTypeEnum,
	Query,
} from "@royalty/httpclient";

@Injectable()
export class OrderService extends HttpService {
	@GET("account/users")
	@Adapter(null, { isAdmin: true })
	getItemOrder(): Observable<any> {
		return null;
	}

	@POST("order/rightPanelCategories")
	@Adapter(null, { isAdmin: false })
	rightPanelCategories(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/getMenuGroupByCategory")
	@Adapter(null, { isAdmin: false })
	getMenuGroupByCategory(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/retryPendingTickets")
	@Adapter(null, { isAdmin: false })
	retryPendingTickets(): Observable<any> {
		return null;
	}


	@POST("order/getMenuGroupByParentId")
	@Adapter(null, { isAdmin: false })
	getMenuGroupByParentId(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/getMenuItemsByGroupId")
	@Adapter(null, { isAdmin: false })
	getMenuItemsByGroupId(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/setClearMenuItem")
	@Adapter(null, { isAdmin: false })
	setClearMenuItem(@Query("ticketItemId") ticketItemId: number,
		@Query("value") value: boolean,
	): Observable<any> {
		return null;
	}
	@POST("order/getKitchenTableInfos")
	@Adapter(null, { isAdmin: false })
	getKitchenTableInfos(): Observable<any> {
		return null;
	}
	@POST("order/GetKitchenGroupInfos")
	@Adapter(null, { isAdmin: false })
	GetKitchenGroupInfos(@Query("printerGroupId") printerGroupId?: number
	): Observable<any> {
		return null;
	}

	@POST("order/SetClearVoidMenuItem")
	@Adapter(null, { isAdmin: false })
	setClearVoidMenuItem(@Query("voidItemId") voidItemId: number,
		@Query("value") value: boolean,
	): Observable<any> {
		return null;
	}

	@POST("order/setClearAllMenuItemByGroup")
	@Adapter(null, { isAdmin: false })
	setClearAllMenuItemByGroup(@Query("printerName") printerName: string,
		@Query("value") value: boolean,
	): Observable<any> {
		return null;
	}




	@POST("order/ReprintTicketItemById")
	@Adapter(null, { isAdmin: false })
	reprintTicketItemById(@Query("ticketItemId") ticketItemId: number
	): Observable<any> {
		return null;
	}


	@POST("order/GetTicketItemPrintFile")
	@Adapter(null, { isAdmin: false, responeType: ResponeTypeEnum.blob })
	getTicketItemPrintFile(@Query("ticketItemId") ticketItemId: number
	): Observable<any> {
		return null;
	}

	@GET("order/getSpecialMenuModifiers")
	@Adapter(null, { isAdmin: false })
	getSpecialMenuModifiers(): Observable<any> {
		return null;
	}

	@POST("order/getModifierGroupsByItemId")
	@Adapter(null, { isAdmin: false })
	getModifierGroupsByItemId(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/getModifierGroupsByParentId")
	@Adapter(null, { isAdmin: false })
	getModifierGroupsByParentId(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/getMenuModifiersByGroupId")
	@Adapter(null, { isAdmin: false })
	getMenuModifiersByGroupId(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/getTicketCouponDiscounts")
	@Adapter(null, { isAdmin: false })
	getTicketCouponDiscounts(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/getTicketDiscounts")
	@Adapter(null, { isAdmin: false })
	getTicketDiscounts(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/removeTicketCouponDiscount")
	@Adapter(null, { isAdmin: false })
	removeTicketCouponDiscount(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/removeTicketDiscount")
	@Adapter(null, { isAdmin: false })
	removeTicketDiscount(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/getCoupons")
	@Adapter(null, { isAdmin: false })
	getCoupons(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/getDiscounts")
	@Adapter(null, { isAdmin: false })
	getDiscounts(@Body data: string): Observable<any> {
		return null;
	}

	@GET("order/getDeliverySetting")
	@Adapter(null, { isAdmin: false })
	getDeliverySetting(): Observable<any> {
		return null;
	}

	@POST("order/addTicketCouponDiscount")
	@Adapter(null, { isAdmin: false })
	addTicketCouponDiscount(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/addTicketDiscount")
	@Adapter(null, { isAdmin: false })
	addTicketDiscount(@Body data: string): Observable<any> {
		return null;
	}
	@POST("order/addTicketMutipleDiscount")
	@Adapter(null, { isAdmin: false })
	addTicketMutipleDiscount(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/addTicketDiscountFromCustomerGift")
	@Adapter(null, { isAdmin: false })
	addTicketDiscountFromCustomerGift(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/getticketbyid")
	@Adapter(null, { isAdmin: false })
	getTicketById(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/createTicket")
	@Adapter(null, { isAdmin: false })
	createTicket(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/updateTicket")
	@Adapter(null, { isAdmin: false })
	updateTicket(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/createAndWait")
	@Adapter(null, { isAdmin: false })
	createAndWait(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/updateAndWait")
	@Adapter(null, { isAdmin: false })
	updateAndWait(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/createAndPrint")
	@Adapter(null, { isAdmin: false })
	createAndPrint(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/printTicketReview")
	@Adapter(null, { isAdmin: false, responeType: ResponeTypeEnum.blob })
	printTicketReview(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/updateAndPrint")
	@Adapter(null, { isAdmin: false })
	updateAndPrint(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/printTicket")
	@Adapter(null, { isAdmin: false })
	printTicket(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/transferTicket")
	@Adapter(null, { isAdmin: false })
	transferTicket(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/payTicket")
	@Adapter(null, { isAdmin: false })
	payTicket(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/printTicketBill")
	@Adapter(null, { isAdmin: false, responeType: ResponeTypeEnum.blob })
	printTicketBill(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/exportTicketAsExcel")
	@Adapter(null, {
		isAdmin: false,
		responeType: ResponeTypeEnum.blob,
	})
	exportTicketAsExcel(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/createSettleTicketByIds")
	@Adapter(null, { isAdmin: false })
	createSettleTicketByIds(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/addTicketTax")
	@Adapter(null, { isAdmin: false })
	addTicketTax(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/removeTicketTax")
	@Adapter(null, { isAdmin: false })
	removeTicketTax(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/updateTicketServiceCharge")
	@Adapter(null, { isAdmin: false })
	updateTicketServiceCharge(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/createAndPay")
	@Adapter(null, { isAdmin: false })
	createAndPay(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/updateAndPay")
	@Adapter(null, { isAdmin: false })
	updateAndPay(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/voidTicket")
	@Adapter(null, { isAdmin: false })
	voidTicket(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/splitTickets")
	@Adapter(null, { isAdmin: false })
	splitTickets(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/transferTicketItem")
	@Adapter(null, { isAdmin: false })
	transferTicketItem(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/voidTicketItem")
	@Adapter(null, { isAdmin: false })
	voidTicketItem(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/changePayment")
	@Adapter(null, { isAdmin: false })
	changePayment(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/changeGuests")
	@Adapter(null, { isAdmin: false })
	changeGuests(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/changeTicketStatus")
	@Adapter(null, { isAdmin: false })
	changeTicketStatus(@Body data: string): Observable<any> {
		return null;
	}

	@POST("order/getVoidedItems")
	@Adapter(null, { isAdmin: false })
	getVoidedItems(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/addCustomerToTicket")
	@Adapter(null, { isAdmin: false })
	addCustomerToTicket(@Body data: any): Observable<any> {
		return null;
	}
	@POST("order/removeCustomerFromTicket")
	@Adapter(null, { isAdmin: false })
	removeCustomerFromTicket(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/GetCustomerHistory")
	@Adapter(null, { isAdmin: false })
	getCustomerHistory(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/GetInvoiceLogs")
	@Adapter(null, { isAdmin: false, showResponeMessage: false })
	GetInvoiceLogs(@Body data: any): Observable<any> {
		return null;
	}


	@POST("order/getAllTicketsToSync")
	@Adapter(null, { isAdmin: false })
	getAllTicketsToSync(): Observable<any> {
		return null;
	}

	@POST("order/saveInvoice")
	@Adapter(null, { isAdmin: false })
	saveInvoice(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/publishInvoice")
	@Adapter(null, { isAdmin: false })
	publishInvoice(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/replaceCanceledInvoice")
	@Adapter(null, { isAdmin: false })
	replaceCanceledInvoice(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/publishAllInvoice")
	@Adapter(null, { isAdmin: false })
	publishAllInvoice(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/updateNoCustomer")
	@Adapter(null, { isAdmin: false })
	updateNoCustomer(@Body data: any): Observable<any> {
		return null;
	}


	@POST("order/generateExcelInvoiceByFkeys")
	@Adapter(null, { isAdmin: false })
	generateExcelInvoiceByFkeys(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/updatePaymentDisplay")
	@Adapter(null, { isAdmin: false })
	updatePaymentDisplay(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/retryUpdateInvoiceStatus")
	@Adapter(null, { isAdmin: false })
	retryUpdateInvoiceStatus(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/sendInvoiceEmail")
	@Adapter(null, { isAdmin: false })
	sendInvoiceEmail(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/waitingReplaceInvoice")
	@Adapter(null, { isAdmin: false })
	waitingReplaceInvoice(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/getConfig")
	@Adapter(null, { isAdmin: false })
	getConfig(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/replaceInvoice")
	@Adapter(null, { isAdmin: false })
	replaceInvoice(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/getCompanyInfoByTaxCode")
	@Adapter(null, { isAdmin: false })
	getCompanyInfoByTaxCode(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/CancelInvoicel")
	@Adapter(null, { isAdmin: false })
	cancelInvoice(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/ModifyTicket")
	@Adapter(null, { isAdmin: false })
	modifyTicket(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/CancelModifyTicket")
	@Adapter(null, { isAdmin: false })
	cancelModifyTicket(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/ListAllTicketTotals")
	@Adapter(null, { isAdmin: false })
	getTicketTotals(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/SaveReOpenTicket")
	@Adapter(null, { isAdmin: false })
	modifyTicketTotals(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/GetTicketPayments")
	@Adapter(null, { isAdmin: false })
	getTicketPayments(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/CreateTicketItemEditHistory")
	@Adapter(null, { isAdmin: false })
	createTicketItemEditHistory(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/DeleteTicketTransactions")
	@Adapter(null, { isAdmin: false })
	deleteTransaction(@Body data: any): Observable<any> {
		return null;
	}

	@POST("order/GetUpdatedTicketInvoice")
	@Adapter(null, { isAdmin: false })
	getUpdatedInvoice(@Body data: any): Observable<any> {
		return null;
	}

	@POST("customer/claimGiftDiscount")
	@Adapter(null, { isAdmin: false })
	applyGiftDiscount(@Body data: any): Observable<any> {
		return null;
	}

	@POST("customer/claimGiftEvoucher")
	@Adapter(null, { isAdmin: false })
	applyGiftEVoucher(@Body data: any): Observable<any> {
		return null;
	}
	@POST("customer/undoClaimGiftEvoucher")
	@Adapter(null, { isAdmin: false })
	undoGiftEVoucher(@Body data: any): Observable<any> {
		return null;
	}

	@POST("customer/claimGiftItem")
	@Adapter(null, { isAdmin: false })
	applyGiftItem(@Body data: any): Observable<any> {
		return null;
	}

	@POST("customer/claimGiftPoints")
	@Adapter(null, { isAdmin: false })
	applyGiftPoint(@Body data: any): Observable<any> {
		return null;
	}
}
